import BaseAPI from './base'

class ConfigPerTemplate extends BaseAPI {
  constructor() {
    super()
    this.client.defaults.baseURL = `${this.fleetURL}/backoffice`
  }

  getConfigPerTemplates = (query) =>
    this.client.get(`/admin/configuration-pers-templates?${query}`)

  getConfigPerTemplate = (id) =>
    this.client.get(`/admin/configuration-pers-templates/${id}`)

  addConfigPerTemplate = (data) => {
    this.client.defaults.headers.Accept = 'multipart/form-data'
    return this.client.post(`/admin/configuration-pers-templates`, data)
  }

  updateConfigPerTemplate = ({ configPerTemplateId, payload }) =>
    this.client.patch(
      `/admin/configuration-pers-templates/${configPerTemplateId}`,
      payload
    )

  deleteConfigPerTemplate = (id) =>
    this.client.delete(`/admin/configuration-pers-templates/${id}`)
}

export default new ConfigPerTemplate()
